import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { DOMRectI } from '../models/scrolling.model';

/**
 * Directiva que controla el scroll de los tabs del menu
 */
@Directive({
    // tslint:disable-next-line:directive-selector
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[scrollToCenter]',
    standalone: false
})

/**
 * Directiva
 */
export class MatTabScrollToCenterDirective implements OnDestroy {
  /**
   * Subscripcion
   */
  subs = new Subscription();

  /**
   * Constructor de la directiva
   *
   * @param element elemento a evaluar
   */
  constructor(
    private element: ElementRef
  ) {
    this.subs.add(
      fromEvent(this.element.nativeElement, 'click').subscribe((clickedContainer: any) => {
        const scrollContainer = this.element.nativeElement.querySelector('.mat-tab-list');
        const currentScrolledContainerPosition: number = scrollContainer.scrollLeft;
        let newPositionScrollTo: number = currentScrolledContainerPosition;
        const leftArrow = document.getElementsByClassName('mat-tab-header-pagination-before');
        const rigthArrow = document.getElementsByClassName('mat-tab-header-pagination-after');

        if (leftArrow.length > 0) {
          Array.from(leftArrow).forEach((elemento: any) => {
            elemento.addEventListener('click', () => {
              newPositionScrollTo -= 100;
              this.scrollToPosition(scrollContainer, this.calculateNewPosition(newPositionScrollTo, clickedContainer));
              this.scrollToPosition(scrollContainer, newPositionScrollTo);
            });
          });
        }
        if (rigthArrow.length > 0) {
          Array.from(rigthArrow).forEach((elemento2: any) => {
            elemento2.addEventListener('click', () => {
              newPositionScrollTo += 100;
              this.scrollToPosition(scrollContainer, this.calculateNewPosition(newPositionScrollTo, clickedContainer));
            });
          });
        }
        if (clickedContainer.srcElement.className === 'mat-tab-label-content' ||
          clickedContainer.srcElement.className.includes('mat-tab-label')) {
          const scrolledButton: DOMRectI = (clickedContainer.target as HTMLElement).getBoundingClientRect();
          const leftXOffset = (window.innerWidth - scrolledButton.width) / 2;
          const currentVisibleViewportLeft = scrolledButton.left;
          const neededLeftOffset = currentVisibleViewportLeft - leftXOffset;
          newPositionScrollTo += neededLeftOffset;
        }

        // Realizar el desplazamiento si se generó una nueva posición
        if (newPositionScrollTo !== currentScrolledContainerPosition) {
          this.scrollToPosition(scrollContainer, newPositionScrollTo);
          scrollContainer.scroll({
            left: newPositionScrollTo,
            behavior: 'smooth',
          });
        }
      })
    );
  }
  /**
   * Cancela la subscripcion
   */
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private calculateNewPosition(newPositionScrollTo: number, clickedContainer: any): number {
    const scrolledButton: DOMRectI = (clickedContainer.target as HTMLElement).getBoundingClientRect();
    const leftXOffset = (window.innerWidth - scrolledButton.width) / 2;
    const currentVisibleViewportLeft = scrolledButton.left;
    const neededLeftOffset = currentVisibleViewportLeft - leftXOffset;
    return newPositionScrollTo += neededLeftOffset;
  }

  private scrollToPosition(container: HTMLElement, newPosition: number): void {
    container.scroll({
      left: newPosition,
      behavior: 'smooth',
    });
  }


}
